/* src/app/pages/ui-kit/components/tab-view/tab-view.component.scss */
.demo {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.controls {
  margin-top: 16px;
}
.controls button {
  padding: 8px 16px;
  background-color: var(--primary-regular-default);
  color: var(--primary-regular-inverse);
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.controls button:hover {
  opacity: 0.8;
}
/*# sourceMappingURL=tab-view.component.css.map */
